import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);    // admin user or false
  const [agent, setAgent] = useState(null);  // agent or false
  const [error, setError] = useState("");

  const fetchMe = useCallback(async () => {
    const t = localStorage.getItem("tara_token");
    if (!t) { setUser(false); }
    else {
      try { const { data } = await api.get("/auth/me"); setUser(data); }
      catch { setUser(false); }
    }
    const at = localStorage.getItem("tara_agent_token");
    if (!at) { setAgent(false); }
    else {
      try { const { data } = await api.get("/agents/me"); setAgent(data); }
      catch { setAgent(false); }
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.access_token) localStorage.setItem("tara_token", data.access_token);
      setUser(data); return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); return false;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("tara_token"); setUser(false);
  };

  const agentLogin = async (code, password) => {
    setError("");
    try {
      const { data } = await api.post("/agents/login", { code, password });
      if (data?.access_token) localStorage.setItem("tara_agent_token", data.access_token);
      setAgent(data); return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); return false;
    }
  };

  const agentLogout = async () => {
    try { await api.post("/agents/logout"); } catch {}
    localStorage.removeItem("tara_agent_token"); setAgent(false);
  };

  return (
    <AuthContext.Provider value={{ user, agent, error, login, logout, agentLogin, agentLogout, fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
